/* Coffee Roast Lab cart page + cart drawer: free shipping check by postal code, bundle bar refresh,
   recommendations, discount labels and the mobile sticky bar.
   Thresholds mirror the live Zapiet rates (tested Oct 15 2026). Totals are in cents. */
(function () {
  if (window.__crlCart) return;
  window.__crlCart = true;

  var REGIONS = {
    A: ['Newfoundland and Labrador', 7500], B: ['Nova Scotia', 7500], C: ['Prince Edward Island', 7500], E: ['New Brunswick', 7500],
    G: ['Quebec', 7000], H: ['Quebec', 7000], J: ['Quebec', 7000],
    K: ['Ontario', 7000], L: ['Ontario', 7000], M: ['Ontario', 7000], N: ['Ontario', 7000], P: ['Ontario', 7000],
    R: ['Manitoba', 7500], S: ['Saskatchewan', 8500], T: ['Alberta', 8000], V: ['British Columbia', 8000],
    X: ['the Northwest Territories and Nunavut', null], Y: ['Yukon', null]
  };
  var KEY = 'crl_postal';
  var SCOPES = '#main-cart-footer, cart-drawer';

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function dollars(c) { return '$' + Math.round(c / 100); }
  function norm(v) { return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function format(v) { var n = norm(v); return n.length > 3 ? n.slice(0, 3) + ' ' + n.slice(3, 6) : n; }
  function readSaved() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function save(v) { try { if (v) { localStorage.setItem(KEY, v); } else { localStorage.removeItem(KEY); } } catch (e) {} }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setHidden(el, hide) { if (el && el.hidden !== hide) el.hidden = hide; }

  function evaluate(code, t) {
    var c = norm(code);
    var out = {
      msg: 'Enter your postal code to check free shipping.',
      short: 'Calculated at checkout',
      sticky: 'Shipping calculated at checkout',
      pct: null,
      meta: ''
    };
    if (!c) return out;
    if (!/^[A-Z][0-9][A-Z]/.test(c)) {
      if (c.length >= 3) out.msg = 'That doesn’t look like a Canadian postal code. Shipping is calculated at checkout.';
      return out;
    }
    var r = REGIONS[c.charAt(0)];
    if (!r) { out.msg = 'Shipping is calculated at checkout.'; return out; }
    if (r[1] === null) { out.msg = 'Shipping to ' + r[0] + ' is calculated at checkout.'; return out; }
    var left = r[1] - t;
    out.pct = Math.max(0, Math.min(100, Math.round((t * 100) / r[1])));
    out.meta = 'Free shipping on orders of ' + dollars(r[1]) + ' or more to ' + r[0] + '.';
    if (left <= 0) {
      out.msg = 'Free shipping to ' + r[0] + ' unlocked.';
      out.short = 'Free';
      out.sticky = 'Free shipping to ' + r[0];
      out.done = true;
    } else {
      out.msg = 'You’re ' + money(left) + ' away from free shipping to ' + r[0] + '.';
      out.sticky = money(left) + ' away from free shipping';
    }
    return out;
  }

  /* Each scope (cart page footer, cart drawer) carries its own cart total, so a stale drawer
     on the cart page never drives the cart page numbers. */
  function renderScope(scope, code) {
    var totalEl = scope.querySelector('[data-crl-cart-total]');
    if (!totalEl) return;
    var res = evaluate(code, parseInt(totalEl.getAttribute('data-crl-cart-total'), 10) || 0);
    var box = scope.querySelector('[data-crl-ship]');
    if (box) {
      var input = box.querySelector('[data-crl-ship-input]');
      if (input && document.activeElement !== input && norm(input.value) !== norm(code)) input.value = format(code);
      setText(box.querySelector('[data-crl-ship-msg]'), res.msg);
      var track = box.querySelector('[data-crl-ship-track]');
      var fill = box.querySelector('[data-crl-ship-fill]');
      var meta = box.querySelector('[data-crl-ship-meta]');
      setHidden(track, res.pct === null);
      setHidden(meta, !res.meta);
      setText(meta, res.meta);
      if (fill && res.pct !== null) {
        var w = res.pct + '%';
        if (fill.style.width !== w) fill.style.width = w;
        fill.classList.toggle('is-done', !!res.done);
      }
    }
    setText(scope.querySelector('[data-crl-ship-short]'), res.short);
    setText(scope.querySelector('[data-crl-ship-sticky]'), res.sticky);
  }

  function renderAll() {
    var code = readSaved();
    var scopes = document.querySelectorAll(SCOPES);
    for (var i = 0; i < scopes.length; i++) renderScope(scopes[i], code);
  }

  /* Show "Bundle saving 5%" instead of the raw BUNDLE5 discount title on line items. */
  function relabelDiscounts() {
    var items = document.querySelectorAll('#main-cart-items .discounts__discount, cart-drawer .discounts__discount');
    for (var i = 0; i < items.length; i++) {
      var nodes = items[i].childNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 3) {
          var m = n.textContent.match(/BUNDLE\s*(\d+)/);
          if (m) n.textContent = ' Bundle saving ' + m[1] + '%';
        }
      }
    }
  }

  /* Cart page only: re-render the bundle section and recommendations when the cart changes. */
  var lastCartKey = null;
  function cartKey() {
    var el = document.querySelector('#main-cart-footer [data-crl-cart-total]');
    return el ? el.getAttribute('data-crl-cart-total') + ':' + el.getAttribute('data-crl-cart-count') : null;
  }
  function refreshBundle() {
    var key = cartKey();
    if (key === null || key === lastCartKey) return;
    var first = lastCartKey === null;
    lastCartKey = key;
    if (first) return;
    var wrap = document.querySelector('[data-crl-bundle-section]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-crl-bundle-section');
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-crl-bundle-section]');
        var current = document.querySelector('[data-crl-bundle-section]');
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function () {});
    loadRecs();
  }

  /* "Round out your bundle": related coffees for the first bag in the cart, rendered by sections/crl-cart-recs.liquid. */
  function loadRecs() {
    var box = document.querySelector('[data-crl-recs]');
    if (!box) return;
    var sectionId = box.getAttribute('data-crl-recs');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { box.hidden = true; return null; }
        var url = root + 'recommendations/products?section_id=' + encodeURIComponent(sectionId) +
          '&product_id=' + cart.items[0].product_id + '&limit=10&intent=related';
        return fetch(url).then(function (r) { return r.text(); });
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-crl-recs-grid]');
        var grid = box.querySelector('[data-crl-recs-grid]');
        if (fresh && grid && fresh.children.length) {
          grid.innerHTML = fresh.innerHTML;
          box.hidden = false;
        } else {
          box.hidden = true;
        }
      })
      .catch(function () { box.hidden = true; });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      renderAll();
      relabelDiscounts();
      refreshBundle();
    });
  }

  function watchCheckoutButton() {
    var btn = document.getElementById('checkout');
    if (!btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('crl-checkout-inview', entries[0].isIntersecting);
    }).observe(btn);
  }

  /* Empty drawer quick add: add the bag and re-render the drawer in place instead of leaving the page. */
  function quickAdd(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-crl-quick-add]')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status || !res.sections) { form.submit(); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      })
      .catch(function () { form.submit(); });
  }

  function init() {
    document.addEventListener('submit', quickAdd);
    /* Delegated, so inputs inside a re-rendered drawer keep working. */
    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('[data-crl-ship-input]')) return;
      var f = format(input.value);
      if (input.value !== f) input.value = f;
      save(norm(f));
      renderAll();
    });
    if ('MutationObserver' in window) {
      ['main-cart-footer', 'main-cart-items'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
      });
      var drawer = document.querySelector('cart-drawer');
      if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
    relabelDiscounts();
    lastCartKey = cartKey();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
      }
    } catch (e) {}
    watchCheckoutButton();
    renderAll();
    loadRecs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
